{
  "tabs": {
    "chat": "چیٹ",
    "reminders": "یاد دہانیاں",
    "calendar": "کیلنڈر",
    "settings": "ترتیبات"
  },
  "common": {
    "cancel": "منسوخ کریں",
    "save": "محفوظ کریں",
    "confirm": "تصدیق کریں",
    "delete": "حذف کریں",
    "back": "پیچھے",
    "close": "بند کریں",
    "edit": "ترمیم کریں",
    "search": "تلاش کریں",
    "all": "سب",
    "loading": "لوڈ ہو رہا ہے...",
    "error": "کچھ غلط ہو گیا",
    "notFound": "نہیں ملا",
    "tryAgain": "براہ کرم دوبارہ کوشش کریں",
    "retry": "دوبارہ کوشش کریں",
    "undo": "واپس لائیں",
    "pullToRefresh": "تازہ کرنے کے لیے کھینچیں",
    "justNow": "ابھی"
  },
  "auth": {
    "welcome": "FishMemory میں خوش آمدید",
    "tagline": "آپ کا WhatsApp یاد دہانی معاون، اب آپ کی جیب میں۔",
    "subtitle": "آپ کا WhatsApp یاد دہانی معاون، اب آپ کی جیب میں۔",
    "phoneLabel": "آپ کا WhatsApp نمبر",
    "phoneHint": "ہم WhatsApp کے ذریعے تصدیقی کوڈ بھیجیں گے",
    "invalidPhone": "براہ کرم درست فون نمبر درج کریں",
    "continue": "جاری رکھیں",
    "enterPhone": "اپنا WhatsApp نمبر درج کریں",
    "phonePlaceholder": "فون نمبر",
    "sendCode": "کوڈ بھیجیں",
    "verifyTitle": "اپنا نمبر تصدیق کریں",
    "otpSentTo": "{{phone}} پر WhatsApp کے ذریعے 6 ہندسوں کا کوڈ بھیجا گیا ہے",
    "enterFullCode": "براہ کرم تمام 6 ہندسے درج کریں",
    "invalidOtp": "غلط کوڈ۔ براہ کرم دوبارہ کوشش کریں۔",
    "otpFailed": "کوڈ بھیجنے میں ناکامی۔ دوبارہ کوشش کریں۔",
    "otpResent": "کوڈ دوبارہ بھیج دیا گیا",
    "resendIn": "{{seconds}} سیکنڈ میں دوبارہ بھیجیں",
    "resendCode": "کوڈ دوبارہ بھیجیں",
    "enterOtp": "وہ کوڈ درج کریں جو آپ کے WhatsApp پر بھیجا گیا ہے",
    "verify": "تصدیق کریں",
    "resend": "کوڈ دوبارہ بھیجیں",
    "wrongNumber": "غلط نمبر؟",
    "backToPhone": "فون پر واپس جائیں",
    "editPhone": "فون نمبر ترمیم کریں",
    "error": "خرابی",
    "setupTitle": "چلیں سیٹ اپ کرتے ہیں",
    "setupSubtitle": "آپ بعد میں ترتیبات میں یہ تبدیل کر سکتے ہیں",
    "namePlaceholder": "آپ کا نام",
    "letsGo": "سیٹ اپ مکمل کریں",
    "skipForNow": "ابھی چھوڑیں"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "پیغام لکھیں...",
    "inputPlaceholder": "پیغام لکھیں...",
    "typing": "FishMemory لکھ رہا ہے...",
    "online": "آن لائن",
    "connecting": "کنیکٹ ہو رہا ہے...",
    "reconnecting": "دوبارہ کنیکٹ ہو رہا ہے...",
    "offline": "آف لائن",
    "empty": "بات چیت شروع کریں",
    "emptyHint": "یاد دہانیاں بنائیں، اپنا شیڈول دیکھیں، یا مدد طلب کریں۔",
    "emptyAction": "نمونہ یاد دہانی بھیجیں",
    "actions": "چیٹ کے اقدامات",
    "keep": "پیغامات رکھیں",
    "clearTitle": "چیٹ صاف کریں",
    "clearConfirm": "کیا آپ اس ڈیوائس سے تمام پیغامات حذف کرنا چاہتے ہیں؟ یہ عمل واپس نہیں ہوگا۔",
    "clear": "چیٹ صاف کریں",
    "optionSelected": "منتخب: {{label}}",
    "sendingSelection": "بھیج رہا ہے...",
    "connectionLost": "دوبارہ کنیکٹ ہو رہا ہے..."
  },
  "reminders": {
    "title": "میری یاد دہانیاں",
    "active": "فعال",
    "today": "آج",
    "thisWeek": "اس ہفتے",
    "history": "تاریخ",
    "items": "آئٹمز",
    "emptyTitle": "ابھی تک کوئی یاد دہانی نہیں",
    "emptySubtitle": "چیٹ سے ایک بنائیں اور یہاں دکھائی دے گی۔",
    "emptyAction": "چیٹ کھولیں",
    "filterActive": "فعال",
    "filterToday": "آج",
    "filterWeek": "اس ہفتے",
    "filterHistory": "تاریخ",
    "emptyState": "ابھی تک کوئی یاد دہانی نہیں۔ چیٹ شروع کریں!",
    "swipeDone": "مکمل",
    "swipeSnooze": "سنووز",
    "swipeDelete": "حذف کریں",
    "search": "یاد دہانیاں تلاش کریں...",
    "upcoming": "آنے والی",
    "completed": "مکمل شدہ",
    "overdue": "مقررہ وقت سے پہلے",
    "tomorrow": "کل",
    "synced": "ہم آہنگ {{value}}",
    "swipeHint": "مزید اقدامات کے لیے یاد دہانی پر سوائپ کریں",
    "noResults": "کوئی یاد دہانی آپ کی تلاش سے میل نہیں کھاتی",
    "noResultsHint": "کسی اور لفظ کی کوشش کریں یا تلاش صاف کریں",
    "deleteAllFailed": "تمام یاد دہانیاں حذف کرنے میں ناکامی"
  },
  "calendar": {
    "title": "کیلنڈر",
    "today": "آج",
    "tomorrow": "کل",
    "completed": "مکمل",
    "noEvents": "کوئی شیڈول نہیں",
    "noEventsSubtitle": "یاد دہانیاں اور کیلنڈر کے واقعات دیکھنے کے لیے تاریخ منتخب کریں۔",
    "googleEvent": "Google Calendar",
    "legendActive": "فعال",
    "legendRecurring": "دہرایا جانے والا",
    "legendDone": "مکمل",
    "legendGoogle": "گوگل",
    "previousMonth": "پچھلا مہینہ",
    "nextMonth": "اگلا مہینہ",
    "previousYear": "پچھلا سال",
    "nextYear": "اگلا سال",
    "goToToday": "آج پر جائیں",
    "all": "سب",
    "active": "فعال",
    "done": "مکمل",
    "paused": "روکا گیا"
  },
  "settings": {
    "title": "ترتیبات",
    "profile": "پروفائل",
    "name": "ظاہری نام",
    "enterName": "اپنا نام درج کریں",
    "language": "زبان",
    "uiLanguage": "ایپ کی زبان",
    "uiLanguageHelp": "صرف اس ڈیوائس پر ایپ کا UI، کیلنڈر لیبلز، اور لے آؤٹ کی سمت تبدیل کرتا ہے۔",
    "serverLanguage": "چیٹ کی زبان",
    "serverLanguageHelp": "آپ کے اکاؤنٹ کے لیے سرور کے جوابات اور یاد دہانی پیغامات کی زبان تبدیل کرتا ہے۔",
    "timezone": "ٹائم زون",
    "currentTimezone": "موجودہ ٹائم زون",
    "timezoneHelp": "تمام یاد دہانی کے اوقات اس ٹائم زون کے مطابق دکھائے جاتے ہیں۔",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "ٹائم زون محفوظ کریں",
    "timezoneSaved": "ٹائم زون اپ ڈیٹ ہو گیا",
    "detect": "پہچانیں",
    "detectFailed": "ٹائم زون شناخت نہیں ہو سکا",
    "autoDetect": "GPS سے خودکار شناخت",
    "notifications": "اطلاعات",
    "notificationsHelp": "فالو اپ یاد دہانیاں ایک یاد دہانی کے بعد بار بار الرٹس کو کنٹرول کرتی ہیں۔ ڈیوائس کی سطح کی اطلاع کی اجازتیں آپ کے فون کی ترتیبات میں ہی منظم ہوتی ہیں۔",
    "pushEnabled": "پش اطلاعات",
    "autoDoneOnFire": "فائر ہوتے ہی خودکار مکمل نشان لگائیں",
    "autoDoneOnFireDesc": "جب بند ہو، یاد دہانیاں فعال رہتی ہیں جب تک آپ انہیں مکمل نہ کریں۔",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "متصل",
    "googleDisconnected": "متصل نہیں",
    "googleConnectedHelp": "نئی یاد دہانیاں خود بخود آپ کے کیلنڈر سے ہم آہنگ ہو سکتی ہیں۔",
    "googleDisconnectedHelp": "یاد دہانیاں اور واقعات کو ہم آہنگ رکھنے کے لیے Google Calendar سے جڑیں۔",
    "googleConnectFailed": "Google Calendar سے جڑنے میں ناکامی",
    "connected": "متصل",
    "disconnected": "متصل نہیں",
    "connect": "جڑیں",
    "disconnect": "منقطع کریں",
    "autoSync": "نئی یاد دہانیاں خودکار ہم آہنگ کریں",
    "autosync": "نئی یاد دہانیاں خودکار ہم آہنگ کریں",
    "subscription": "رکنیت",
    "trialUsed": "آزمائش: {{used}}/{{total}} استعمال شدہ",
    "trialStatus": "آزمائش دستیاب",
    "activeStatus": "فعال رکنیت",
    "expiredStatus": "رکنیت ختم ہو گئی",
    "unsubscribedStatus": "رکنیت نہیں لی گئی",
    "about": "کے بارے میں",
    "version": "ورژن",
    "logout": "لاگ آؤٹ",
    "logoutTitle": "لاگ آؤٹ",
    "logoutConfirm": "کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟",
    "noName": "کوئی نام مقرر نہیں",
    "serverConnection": "سرور کنکشن",
    "serverUrl": "سرور URL",
    "serverEdit": "ترمیم کریں",
    "saveReconnect": "محفوظ کریں اور دوبارہ کنیکٹ کریں",
    "resetDefault": "ڈیفالٹ پر ری سیٹ کریں",
    "invalidServerUrlTitle": "غلط سرور URL",
    "invalidServerUrlMessage": "براہ کرم ایک درست http یا https سرور URL درج کریں، مثلاً https://example.com",
    "uiLanguageChangeFailed": "ایپ کی زبان تبدیل کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
    "serverLanguageChangeFailed": "چیٹ کی زبان تبدیل کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
    "timezoneChangeFailed": "ٹائم زون تبدیل کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
    "autoSyncChangeFailed": "خودکار ہم آہنگی اپ ڈیٹ کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
    "nameChangeFailed": "ظاہری نام اپ ڈیٹ کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "یاد دہانی کی تفصیلات",
    "editTime": "وقت ترمیم کریں",
    "rename": "نام تبدیل کریں",
    "snooze": "سنووز کریں",
    "snooze15": "15 منٹ کے لیے سنووز کریں",
    "pause": "روکیں",
    "pauseReminder": "یاد دہانی روکیں",
    "resume": "دوبارہ شروع کریں",
    "resumeReminder": "یاد دہانی دوبارہ شروع کریں",
    "skip": "اگلا چھوڑیں",
    "skipOccurrence": "یہ واقعہ چھوڑیں",
    "syncGoogle": "گوگل سے ہم آہنگ کریں",
    "delete": "حذف کریں",
    "deleteTitle": "یاد دہانی حذف کریں",
    "deleteConfirm": "یہ یاد دہانی مستقل طور پر حذف ہو جائے گی۔",
    "deleteRecurringTitle": "دہرائی جانے والی یاد دہانی حذف کریں",
    "deleteRecurringMessage": "کیا آپ اس واقعہ کو چھوڑنا چاہتے ہیں یا پوری سیریز حذف کرنا چاہتے ہیں؟",
    "deleteThisOccurrence": "یہ واقعہ چھوڑیں",
    "deleteEntireSeries": "پورا سلسلہ حذف کریں",
    "done": "مکمل",
    "markDone": "مکمل کے طور پر نشان لگائیں",
    "undo": "واپس لائیں",
    "undoPrompt": "کیا آپ اسے دوبارہ فعال کرنا چاہتے ہیں؟ ابھی بحال کریں۔",
    "recurring": "دہرایا جانے والا",
    "nextRun": "اگلا چکر",
    "oneTime": "ایک بار",
    "pending": "زیر التواء",
    "sent": "بھیجا گیا",
    "paused": "روکا گیا",
    "active": "فعال",
    "snoozed": "سنووز کیا گیا",
    "localTime": "آپ کے مقامی وقت میں دکھایا گیا",
    "recurrence": "دہراؤ",
    "created": "بنائی گئی",
    "tags": "ٹیگز",
    "fireCount": "بار فائر ہوا",
    "actions": "عمل",
    "none": "کوئی نہیں",
    "snoozeFailed": "یاد دہانی سنووز کرنے میں ناکامی",
    "pauseFailed": "یاد دہانی روکنے میں ناکامی",
    "resumeFailed": "یاد دہانی دوبارہ شروع کرنے میں ناکامی",
    "skipFailed": "یاد دہانی چھوڑنے میں ناکامی",
    "doneFailed": "یاد دہانی مکمل نشان لگانے میں ناکامی",
    "undoFailed": "یاد دہانی کی حالت بحال کرنے میں ناکامی",
    "deleteFailed": "یاد دہانی حذف کرنے میں ناکامی",
    "rescheduleTitle": "دوبارہ شیڈول کریں؟",
    "rescheduleMsg": "یہ یاد دہانی مقررہ وقت سے پہلے ہے۔ کیا آپ اسے دوبارہ شیڈول کرنا چاہتے ہیں؟",
    "reschedule15": "15 منٹ میں",
    "reschedule60": "1 گھنٹے میں",
    "keepOverdue": "جیسے ہے ویسا ہی رکھیں"
  },
  "onboarding": {
    "slide1Title": "FishMemory میں خوش آمدید",
    "slide1Sub": "آپ کا ذاتی یاد دہانی معاون — WhatsApp سے چلنے والا اور آپ کی جیب کے لیے بنایا گیا۔",
    "slide2Title": "بس قدرتی بات کریں",
    "slide2Sub": "یاد دہانیاں ویسے ٹائپ کریں جیسے آپ سوچتے ہیں: \"مجھے کل 3 بجے ماں کو کال کرنے کی یاد دہانی دلائیں\" — ہم باقی سنبھالیں گے۔",
    "slide3Title": "کبھی کچھ نہ بھولیں",
    "slide3Sub": "بروقت اطلاعات حاصل کریں، ٹیگز کے ساتھ منظم رہیں، اور ہر اہم چیز پر نظر رکھیں۔",
    "getStarted": "شروع کریں",
    "next": "اگلا",
    "firstReminderTitle": "اپنی پہلی یاد دہانی بنائیں!",
    "firstReminderHint": "کچھ ایسا ٹائپ کرنے کی کوشش کریں:",
    "firstReminderExample": "مجھے کل صبح 9 بجے پانی پینے کی یاد دہانی دلائیں",
    "gotIt": "سمجھ گیا!",
    "notifRationaleTitle": "وقت پر رہیں",
    "notifRationaleBody": "FishMemory کو وقت پر یاد دلانے کے لیے اطلاعات کی ضرورت ہے۔ آپ کو صرف وہی یاد دہانیاں ملیں گی جو آپ بنائیں گے۔",
    "notifRationaleAllow": "اطلاعات فعال کریں",
    "notifRationaleLater": "شاید بعد میں",
    "swipeHint": "فوری اقدامات کے لیے دائیں سوائپ کریں →",
    "calendarDragHint": "پھیلانے کے لیے گھسیٹیں ↕"
  }
}
